export const getChosung = (word: string) => {
  const chosungs = [
    'ㄱ',
    'ㄲ',
    'ㄴ',
    'ㄷ',
    'ㄸ',
    'ㄹ',
    'ㅁ',
    'ㅂ',
    'ㅃ',
    'ㅅ',
    'ㅆ',
    'ㅇ',
    'ㅈ',
    'ㅉ',
    'ㅊ',
    'ㅋ',
    'ㅌ',
    'ㅍ',
    'ㅎ',
  ]
  let chosungIndex = Math.floor((word.charCodeAt(0) - 0xac00) / (21 * 28))
  return chosungs[chosungIndex]
}
